import { Upload, X } from 'lucide-react';

const BusinessLogoSection = ({ logoPreviewUrl, onLogoFileChange, onRemoveLogo }) => {
  return (
    <div className="space-y-2 bg-slate-50/70 p-3.5 sm:p-4 rounded-2xl border border-slate-100">
      <label className="block text-xs font-bold text-slate-700 tracking-wide mb-1.5">
        Business logo
      </label>
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
        <div className="relative w-14 h-14 sm:w-16 sm:h-16 rounded-2xl bg-white border-2 border-dashed border-slate-200 flex items-center justify-center overflow-hidden shrink-0 group shadow-sm">
          {logoPreviewUrl ? (
            <>
              <img src={logoPreviewUrl} alt="Logo preview" className="w-full h-full object-cover" />
              <button
                type="button"
                onClick={onRemoveLogo}
                className="absolute top-1 right-1 p-1 bg-black/50 text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer"
              >
                <X size={12} />
              </button>
            </>
          ) : (
            <Upload size={20} className="text-slate-400" />
          )}
        </div>
        <div>
          <label className="cursor-pointer inline-flex items-center gap-2 px-3.5 py-2 bg-white hover:bg-slate-100 text-slate-700 font-semibold text-xs rounded-xl border border-slate-200 shadow-sm transition-all">
            <Upload size={14} /> {logoPreviewUrl ? 'Change Logo' : 'Upload Logo'}
            <input
              type="file"
              accept="image/*"
              onChange={onLogoFileChange}
              className="hidden"
            />
          </label>
          <p className="text-[10px] sm:text-[11px] text-slate-400 mt-1">
            Recommended: Square logo image (JPG, PNG, WEBP)
          </p>
        </div>
      </div>
    </div>
  );
};

export default BusinessLogoSection;
